<template>
    <div class="pin-add" :class="{'pin-add_working': content.length > 0}">
        <TextareaAutosize
            :name="'pins-add'"
            class="pin-add__input" 
            :class="getContentSize" 
            rows="1"
            v-model="content"
            placeholder="Создайте пост..."
            maxlength="2000"
        />
        <div class="pin-add-panel">
            <div class="pin-add-panel__item" @click="smiles = !smiles">
                <img src="@/assets/images/icons/smile.svg" width="24px"/>
                <div class="pin-emoji" v-show="smiles" @click.stop>
                    <VEmojiPicker
                        :emojiSize="24"
                        :emojisByRow="6"
                        :continuousList="true"
                        @select="addSmile"/>
                    </div>
            </div>
            <!-- <div class="pin-add-panel__item" @click="upload = !upload">
                <img src="@/assets/images/icons/upload.svg">
                <div class="dropdown" v-if="upload">
                    <div class="dropdown-item">
                            <img src="@/assets/images/icons/image.svg">
                            <input
                                class="image-loader"
                                type="file"
                                multiple
                                @change="addImages($event, 'pins')"
                                name="pin-image"
                                max-size="10000"
                                accept="image/*"
                                title="Загрузить фото"
                            />
                    </div>
                    <div class="dropdown-item">
                            <img src="@/assets/images/icons/video.svg">
                            <input
                                class="image-loader"
                                type="file"
                                multiple
                                @change="addImages($event, 'pins')"
                                name="pin-image"
                                max-size="10000"
                                accept="image/*"
                                title="Загрузить фото"
                            />
                    </div>
                </div>
            </div> -->
            <div class="pin-add-panel__item">
                <img src="@/assets/images/icons/image.svg">
                <input
                    class="image-loader"
                    type="file"
                    multiple
                    @change="addImages($event, 'pins')"
                    name="pin-image"
                    max-size="10000"
                    accept="image/*"
                    title="Загрузить фото"
                />
            </div>
            <div class="pin-add-panel__item" v-if="!loading" @click="createPin()">
                <img src="@/assets/images/icons/plane.svg">
            </div>
            <div class="pin-add-panel__item" v-else>
                <Loader :color="'black'" />
            </div>
        </div>
        <div class="pin-masonry" v-if="media.length > 0">
            <div 
                class="pin-masonry__item"
                @click="showFullPhoto($event, media, index)"
                :class="[getImageClass(media), item.orientation]" 
                v-for="(item, index) in media" :key="index"
            > 
                <div class="pin-masonry__delete" @click.stop="deleteMedia(index)">
                    <img src="@/assets/images/icons/delete.svg">
                </div>
                <img :src="item.url">
            </div>
            <div class="pin-masonry__switcher" @click.stop="changeTypeMedia()">
                <img v-if="media_type === 'full'" src="@/assets/images/icons/category.svg">
                <img v-if="media_type === 'masonry'" src="@/assets/images/icons/image.svg">
                <p>{{media_type === 'masonry' ? 'Слайдером' : 'Плиткой'}}</p>
            </div>
        </div>
    </div>
</template>
<script>
const Images = require('@/services/media/images')
import Loader from '@/components/UI/Loader'
import { VEmojiPicker } from 'v-emoji-picker';

export default {
    name: 'PinAdd',
    data () {
        return {
            loading: false,
            content: '',
            media: [],
            smiles: false,
            media_type: 'masonry',
            upload: false
        }
    },
    components: {
        VEmojiPicker,
        Loader
    },
    computed: {
        getContentSize() {
            let result = null;
            if (this.content.length < 100) {
                if (this.media.length > 0) {
                    result = 'content_big_media'
                } else {
                    result = 'content_big'
                }
            } else if (this.content.length < 200) {
                if (this.media.length > 0) {
                    result = 'content_big_media'
                } else {
                    result = 'content_big'
                } 
            }
            return result
        },
    },
    methods: {
        changeTypeMedia() {
            this.media_type = this.media_type === 'full' ? 'masonry' : 'full'
        },
        deleteMedia(index) {
            this.media.splice(index, 1)
        },
        async createPin(){
            this.loading = true
            if (this.content.length > 0 || this.media.length > 0) {
                await this.$store.dispatch('createPin', {
                    media_type: this.media_type,
                    content: this.content,
                    media: this.media
                })
                .then(response => {
                    response.score 
                        ? this.$store.dispatch('addScore', response.score)
                        : ''
                    this.clearAll()
                })
            } else {
                this.$store.dispatch('addNotification', {message: "Заполните поле контента"})
            }
            this.loading = false
        },
        addSmile(smile) {
            this.content += smile.data;
        },
        async addImages(input) {
            let images = await Images.readImages(input.target.files, {max: 6, maxSize: 10});
            if (images.error) {
                this.$store.dispatch('addError', {message: images.error})
            } else {
                this.media = this.media.concat(images);
            }
        },
        clearAll() {
            this.content = ''
            this.media = []
        },
        showFullPhoto(event, photos, active) {
            this.$store.dispatch('setPhotos', {photos: photos, active: active})
            this.$store.dispatch('setPhotosState', true)
        },
        getImageClass(images) {
            let result = '';
            switch (images.length) {
                case 1:
                result = 'size_one';
                break;
                case 2:
                result = 'size_two';
                break;
                case 3:
                result = 'size_tree';
                break;
                case 4:
                result = 'size_four';
                break;
                case 5:
                result = 'size_five';
                break;
                case 6:
                result = 'size_six';
                break;

                default:
                break;
            }
            return result;
        },
    }
}
</script>
<style lang="stylus" scoped>
.pin
    &-emoji
        position absolute
        top 38px
        right -85px
        background-color var(--blocks)
        z-index 2

    &-add
        z-index 3
        width 100%
        position relative
        margin-bottom 20px
        // +to-width(540px)
        //     border-radius 0
        //     box-shadow none

        &_working
            padding-bottom 45px

        &__input
            width 100%
            font-size 14px
            line-height 22px
            border none
            padding-right 40px
            color black
            padding 16px 25px
            background-color var(--blocks)
            border 1px solid var(--blocks-border)
            box-shadow var(--blocks-shadow)
            border-radius 20px
            &.content_big
                font-size 22px
                line-height 28px
                +to-width(420px)
                    font-size 18px
                &_media
                    font-size 18px
        
        &-panel
            position absolute
            right 20px
            // bottom 12px
            top 10px
            display flex
            background-color var(--blocks)
            border-radius 10px
            &__item
                cursor pointer
                position relative
                transition 0.3s all
                // margin-left 5px
                display flex
                align-items center
                padding 10px
                &:hover
                    img
                        opacity 0.7
                
                .dropdown
                    right -4px
                    top 100%
                    bottom initial

                    &-item
                        padding 10px
                        position relative
                        &:hover
                            background-color white
        
        .pin-masonry
            margin-top 10px
            width auto
            margin-left -25px
            margin-right -25px
            padding-bottom 0
            position relative
            &__item
                position relative

            &__delete
                width 40px
                height 40px
                position absolute
                right 20px
                top 20px
                padding 4px
                background-color white
                border-radius 5px
                display flex
                align-items center
                justify-content center
                box-shadow 0px 0px 30px rgba(162, 162, 162, 0.15)
            
            &__switcher
                position absolute
                right 20px
                bottom 20px
                display flex
                align-items center
                box-shadow 0px 0px 30px rgba(162, 162, 162, 0.15)
                padding 6px
                background-color white
                border-radius 5px
                cursor pointer
                p
                    font-size 14px
                    font-weight 600
                    margin-left 5px
</style>